import { addDays } from "date-fns";
import { useMemo } from "react";
import { BooleanInput, required, useRecordContext } from "react-admin";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { TransformGroupCertificationData } from "./types";

const DynamicEndDateInputs = ({ formData }: { formData: TransformGroupCertificationData }) => {
  const record = useRecordContext();
  const disabled = formData?.disable_end_date !== undefined ? !!formData?.disable_end_date : !record?.end_date;
  const minDate = useMemo(() => addDays(new Date(), 3), []);
  return (
    <>
      <CustomDateTimeInput
        source="end_date"
        disabled={disabled}
        minDate={minDate}
        validate={disabled ? [] : [required()]}
      />

      <BooleanInput source="disable_end_date" defaultValue={!record?.end_date} sx={{ minWidth: "190px" }} />
    </>
  );
};

export default DynamicEndDateInputs;
